import React from 'react';
// import { useSelector } from 'react-redux';
// import { RootState } from '@/redux/reducers';
import { RouteComponentProps } from '@reach/router';
// import IconClosedBrand from '@/assets/icons/closed-brand.svg';
import './styles.less';

export interface NotFoundProps extends RouteComponentProps {}

const NotFound: React.FC<NotFoundProps> = () => {
  return (
    <div className="NotFound">
      {/* <div className="NotFound-image">
        <img src={IconClosedBrand} alt="Open Banking" />
      </div>
      <h1 className="NotFound-title">We Are Sorry</h1> */}
      <p className="NotFound-description">The site you are looking for does not exist</p>
    </div>
  );
};

export default NotFound;
